module.exports = __webpack_public_path__ + "img/aws-white.c501783f.png";